import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <section className="card">
      <h1 className="card__title">404</h1>
      <p className="card__subtitle">La página que buscas no existe.</p>
      <Link className="btn" to="/login">
        Volver al inicio
      </Link>
    </section>
  );
}
